/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { CancelablePromise } from '../core/CancelablePromise';
import type { BaseHttpRequest } from '../core/BaseHttpRequest';

export class DailyScheduleControllerService {

    constructor(public readonly httpRequest: BaseHttpRequest) {}

    /**
     * @returns string OK
     * @throws ApiError
     */
    public setTvl({
        targetDate,
    }: {
        targetDate?: string,
    }): CancelablePromise<'OK' | 'ERROR'> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/schedule/daily/tvl',
            query: {
                'targetDate': targetDate,
            },
        });
    }

    /**
     * @returns string OK
     * @throws ApiError
     */
    public setDailyTrxFeeAvg({
        targetDate,
    }: {
        targetDate?: string,
    }): CancelablePromise<'OK' | 'ERROR'> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/schedule/daily/transaction/fee/avg',
            query: {
                'targetDate': targetDate,
            },
        });
    }

    /**
     * @returns string OK
     * @throws ApiError
     */
    public setNetflowUntil({
        targetDate,
    }: {
        targetDate?: string,
    }): CancelablePromise<'OK' | 'ERROR'> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/schedule/daily/netflow',
            query: {
                'targetDate': targetDate,
            },
        });
    }

}
